import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a86b370"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-part-a-trust-account-details" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-3 mb-3" }, "Trust Account Details", -1))
const _hoisted_3 = { class: "questions-main" }

export function render(_ctx, _cache) {
  const _component_RadioButtonBranchList = _resolveComponent("RadioButtonBranchList")
  const _component_RadioButtonHorizontal = _resolveComponent("RadioButtonHorizontal")
  const _component_RadioButtonVertical = _resolveComponent("RadioButtonVertical")
  const _component_MultiRadioBoxes = _resolveComponent("MultiRadioBoxes")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.loadingContent && !_ctx.errorLoadingContent)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formPartAData.trustAccountDetails.atcsMainQuestions, (q, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (q.atcsQuestionTypeId==15)
                  ? (_openBlock(), _createBlock(_component_RadioButtonBranchList, {
                      key: 0,
                      class: "mt-3 mb-3",
                      question: _ctx.formPartAData.trustAccountDetails.atcsMainQuestions[i],
                      "onUpdate:question": $event => ((_ctx.formPartAData.trustAccountDetails.atcsMainQuestions[i]) = $event),
                      onValidForm: $event => (_ctx.validationForm(i, $event))
                    }, null, 8, ["question", "onUpdate:question", "onValidForm"]))
                  : _createCommentVNode("", true),
                (q.atcsQuestionTypeId==10)
                  ? (_openBlock(), _createBlock(_component_RadioButtonHorizontal, {
                      key: 1,
                      class: "mt-3 mb-3",
                      question: _ctx.formPartAData.trustAccountDetails.atcsMainQuestions[i],
                      "onUpdate:question": $event => ((_ctx.formPartAData.trustAccountDetails.atcsMainQuestions[i]) = $event),
                      onValidForm: $event => (_ctx.validationForm(i, $event))
                    }, null, 8, ["question", "onUpdate:question", "onValidForm"]))
                  : _createCommentVNode("", true),
                (q.atcsQuestionTypeId==11)
                  ? (_openBlock(), _createBlock(_component_RadioButtonVertical, {
                      key: 2,
                      class: "mt-3 mb-3",
                      question: _ctx.formPartAData.trustAccountDetails.atcsMainQuestions[i],
                      "onUpdate:question": $event => ((_ctx.formPartAData.trustAccountDetails.atcsMainQuestions[i]) = $event),
                      onValidForm: $event => (_ctx.validationForm(i, $event))
                    }, null, 8, ["question", "onUpdate:question", "onValidForm"]))
                  : _createCommentVNode("", true),
                (q.atcsQuestionTypeId==17)
                  ? (_openBlock(), _createBlock(_component_MultiRadioBoxes, {
                      key: 3,
                      class: "mt-3 mb-3",
                      question: _ctx.formPartAData.trustAccountDetails.atcsMainQuestions[i],
                      "onUpdate:question": $event => ((_ctx.formPartAData.trustAccountDetails.atcsMainQuestions[i]) = $event),
                      onValidForm: $event => (_ctx.validationForm(i, $event))
                    }, null, 8, ["question", "onUpdate:question", "onValidForm"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256))
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}